module.exports = [
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			500,
			0,
			500,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "A Soul's Bane",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "A Tail of Two Cats",
		"relatedQuests": [
			"Icthlarin's Little Helper"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			30,
			0,
			0,
			0,
			35,
			0,
			0,
			0,
			19,
			0,
			0,
			0,
			0,
			0,
			18,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			2500,
			1000,
			0,
			0,
			1000,
			0,
			0,
			0,
			0,
			0,
			1000,
			0,
			0,
			0,
			0
		],
		"name": "Animal Magnetism",
		"relatedQuests": [
			"Restless Ghost",
			"Ernest the Chicken",
			"Priest in Peril"
		]
	},
	{
		"requirement": [
			0,
			15,
			0,
			0,
			0,
			0,
			25,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			3000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			3000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Another Slice of H.A.M",
		"relatedQuests": [
			"Death to the Dorgeshuun",
			"The Digsite",
			"The Giant Dwarf"
		]
	},
	{
		"requirement": [
			0,
			0,
			30,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			50,
			40,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			5000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			5000,
			5000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Between a Rock...",
		"relatedQuests": [
			"Fishing Contest",
			"Dwarf Cannon"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			30,
			0,
			0,
			30,
			0,
			5,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			735,
			0,
			0,
			1470,
			0,
			262,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Big Chompy Bird Hunting",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			1250,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Biohazard",
		"relatedQuests": [
			"Plague City"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Black Knights' Fortress",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			40,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			45,
			50,
			0,
			0,
			42,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			7000,
			7000,
			0,
			0,
			7000,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Cabin Fever",
		"relatedQuests": [
			"Rum Deal",
			"Pirate's Treasure"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Clock Tower",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			30,
			0,
			0,
			0,
			30,
			0,
			0,
			0,
			0,
			10,
			34
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			2000,
			0,
			0,
			0,
			5000,
			0,
			0,
			0,
			0,
			0,
			1500
		],
		"name": "Cold War",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			7000,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Contact!",
		"relatedQuests": [
			"Gertrude's Cat",
			"Icthlarin's Little Helper",
			"Prince Ali Rescue"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			300,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Cook's Assistant",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			20,
			0,
			0,
			0,
			0,
			25,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			1000,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Creature of Fenkenstrain",
		"relatedQuests": [
			"Priest in Peril",
			"Restless Ghost"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			40,
			0,
			0,
			0,
			33,
			0,
			0,
			0,
			0,
			0,
			32,
			0,
			20,
			0,
			26,
			22,
			0,
			0,
			0,
			0,
			5
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			7000,
			6000,
			0,
			0,
			0,
			0,
			2000
		],
		"name": "Darkness of Hallowvale",
		"relatedQuests": [
			"In Aid of the Myreque"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Death Plateau",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			23,
			23,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			2000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			2000,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Death to the Dorgeshuun",
		"relatedQuests": [
			"The Lost Tribe"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Demon Slayer",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			50,
			0,
			0,
			0,
			0,
			50,
			0,
			0,
			0,
			0,
			0,
			53,
			10,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			20000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Desert Treasure",
		"relatedQuests": [
			"The Digsite",
			"The Tourist Trap",
			"Temple of Ikov",
			"Priest in Peril",
			"Waterfall Quest",
			"Troll Stronghold"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			50,
			0,
			0,
			0,
			65,
			0,
			0,
			0,
			0,
			0,
			0,
			50,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			5000,
			0,
			0,
			0,
			6500,
			0,
			0,
			0,
			0,
			0,
			0,
			5000,
			0,
			0
		],
		"name": "Devious Minds",
		"relatedQuests": [
			"Doric's Quest",
			"Troll Stronghold",
			"Wanted!",
			"Recruitment Drive"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			10,
			10,
			25,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			15300,
			2000,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "The Digsite",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			1300,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Doric's Quest",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			18650,
			18650,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Dragon Slayer",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			15000,
			0,
			0,
			10000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Dream Mentor",
		"relatedQuests": [
			"Lunar Diplomacy",
			"Eadgar's Ruse"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			250,
			0
		],
		"name": "Druidic Ritual",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			750,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Dwarf Cannon",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			44,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			11000,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Eadgar's Ruse",
		"relatedQuests": [
			"Druidic Ritual"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			27,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			2500,
			0
		],
		"name": "Eagles' Peak",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			20,
			20,
			20,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			5000,
			5000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Elemental Workshop I",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			20,
			0,
			0,
			0,
			0,
			0,
			0,
			30,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			7500,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Elemental Workshop II",
		"relatedQuests": [
			"Elemental Workshop I"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			43,
			39,
			0,
			0,
			0,
			0,
			45,
			50,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			7000,
			0,
			0,
			0,
			0,
			7000,
			7000,
			0,
			7000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Enakhra's Lament",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			20,
			36,
			0,
			0,
			0,
			0,
			0,
			0,
			30,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			1500,
			0,
			0,
			4000,
			2000,
			0,
			0,
			0,
			0,
			0,
			0,
			3000,
			0,
			0,
			0
		],
		"name": "Enlightened Journey",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Ernest the Chicken",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			5
		],
		"reward": [
			0,
			2000,
			0,
			0,
			0,
			0,
			0,
			1000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			3500,
			0,
			0,
			0
		],
		"name": "Fairytale I - Growing Pains",
		"relatedQuests": [
			"Lost City",
			"Nature Spirit"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			57,
			0,
			40,
			0,
			49,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			3500,
			0,
			2500,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Fairytale II - Cure a Queen",
		"relatedQuests": [
			"Fairytale I - Growing Pains"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			59,
			0,
			0,
			0,
			0,
			0,
			40,
			40,
			40,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Family Crest",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			12175,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			2175,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Fight Arena",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			10,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			2437,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Fishing Contest",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			22,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Forgettable Tale...",
		"relatedQuests": [
			"The Giant Dwarf",
			"Fishing Contest"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			25,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			5000,
			0,
			0,
			0
		],
		"name": "Garden of Tranquility",
		"relatedQuests": [
			"Creature of Fenkenstrain"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			1525,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Gertrude's Cat",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			20,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			25,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			2400,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Ghosts Ahoy",
		"relatedQuests": [
			"Priest in Peril",
			"Restless Ghost"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			200,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Goblin Diplomacy",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			71,
			0,
			0,
			0,
			0,
			0,
			0,
			52,
			59,
			58,
			0,
			45,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			5000,
			0,
			0,
			0,
			0,
			14000,
			0,
			0,
			0,
			0,
			0,
			0,
			5000,
			6000,
			6000,
			0,
			4000,
			0,
			0,
			0
		],
		"name": "Grim Tales",
		"relatedQuests": [
			"Witch's House"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			35,
			0,
			0,
			0,
			15,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			22000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Haunted Mine",
		"relatedQuests": [
			"Priest in Peril"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			1500,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Hazeel Cult",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			53,
			0,
			53,
			0,
			0,
			0,
			0,
			50,
			25,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			3075,
			3075,
			3075,
			3075,
			2075,
			0,
			0,
			2825,
			1575,
			0,
			2725,
			1575,
			0,
			2257,
			2575,
			1325,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Heroes Quest",
		"relatedQuests": [
			"Shield of Arrav",
			"Lost City",
			"Merlin's Crystal",
			"Dragon Slayer"
		]
	},
	{
		"requirement": [
			0,
			15,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			15300,
			0,
			0,
			0,
			11000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Holy Grail",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			35,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			4662,
			0,
			4662,
			0,
			4662,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Horror from the Deep",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			4000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			4000,
			4500,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Icthlarin's Little Helper",
		"relatedQuests": [
			"Gertrude's Cat"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			875,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Imp Catcher",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			7,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			2000,
			2000,
			2000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			2000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "In Aid of the Myreque",
		"relatedQuests": [
			"In Search of the Myreque",
			"Nature Spirit"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			600,
			600,
			600,
			600,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			600,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "In Search of the Myreque",
		"relatedQuests": [
			"Nature Spirit"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			775,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Jungle Potion",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			65,
			0,
			0,
			0,
			0,
			45,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			33000,
			0,
			0,
			0,
			0,
			5000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "King's Ransom",
		"relatedQuests": [
			"Merlin's Crystal",
			"Holy Grail",
			"Murder Mystery",
			"Black Knights' Fortress",
			"One Small Favour"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			50,
			0,
			0,
			42,
			56,
			0,
			50,
			0,
			0,
			0,
			50,
			50,
			52,
			0,
			50,
			50,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Legends Quest",
		"relatedQuests": [
			"Heroes Quest",
			"Family Crest",
			"Shilo Village",
			"Underground Pass",
			"Waterfall Quest"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			36,
			0,
			0,
			0,
			31,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Lost City",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			40,
			0,
			0,
			0,
			0,
			65,
			0,
			55,
			0,
			0,
			49,
			61,
			0,
			60,
			5,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			5000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			5000,
			0,
			0
		],
		"name": "Lunar Diplomacy",
		"relatedQuests": [
			"Lost City",
			"The Fremennik Trials",
			"Shilo Village"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			20,
			40,
			40,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			1000,
			0,
			0,
			0,
			0,
			0,
			0,
			1000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Making History",
		"relatedQuests": [
			"Priest in Peril",
			"Restless Ghost"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Merlin's Crystal",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Misthalin Mystery",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			2000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Monk's Friend",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			35000,
			35000,
			35000,
			35000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Monkey Madness",
		"relatedQuests": [
			"The Grand Tree",
			"Tree Gnome Village"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			70,
			0,
			0,
			0,
			55,
			55,
			69,
			0,
			0,
			60,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			20000,
			15000,
			25000,
			0,
			0,
			15000,
			0
		],
		"name": "Monkey Madness 2",
		"relatedQuests": [
			"Enlightened Journey",
			"The Eyes of Glouphrie",
			"Recipe for Disaster - Awowogei",
			"Troll Stronghold",
			"Watchtower",
			"Monkey Madness"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			20,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Mountain Daughter",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			60,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			50,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			25000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			25000,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Mourning's Ends Part I",
		"relatedQuests": [
			"Roving Elves",
			"Big Chompy Bird Hunting",
			"Sheep Herder"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			20000,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Mourning's Ends Part II",
		"relatedQuests": [
			"Mourning's Ends Part I"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			1406,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Murder Mystery",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			10,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			20,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			10000,
			0,
			0,
			0,
			5000,
			0,
			0,
			0
		],
		"name": "My Arm's Big Adventure",
		"relatedQuests": [
			"Eadgar's Ruse",
			"The Feud",
			"Jungle Potion"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			2000,
			0,
			2000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			3000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Nature Spirit",
		"relatedQuests": [
			"Priest in Peril",
			"Restless Ghost"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			10,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			875,
			875,
			875,
			875,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			2250,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Observatory Quest",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			50,
			0,
			0,
			40,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			12000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Olaf's Quest",
		"relatedQuests": [
			"The Fremennik Trials"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			25,
			30,
			0,
			18,
			36,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "One Small Favour",
		"relatedQuests": [
			"Rune Mysteries",
			"Shilo Village",
			"Druidic Ritual"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Pirate's Treasure",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			2425,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Plague City",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			1406,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Priest in Peril",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Prince Ali Rescue",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			500,
			0,
			500,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Rag and Bone Man",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			4500,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Rat Catchers",
		"relatedQuests": [
			"Icthlarin's Little Helper"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			10,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Recipe for Disaster - Beginning",
		"relatedQuests": [
			"Cook's Assistant"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Recipe for Disaster - Dwarf",
		"relatedQuests": [
			"Recipe for Disaster - Beginning",
			"Fishing Contest"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Recipe for Disaster - Goblins",
		"relatedQuests": [
			"Recipe for Disaster - Beginning",
			"Goblin Diplomacy"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			31,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Recipe for Disaster - Pirate Pete",
		"relatedQuests": [
			"Recipe for Disaster - Beginning"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			40,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Recipe for Disaster - Lumbridge Guide",
		"relatedQuests": [
			"Recipe for Disaster - Beginning",
			"Big Chompy Bird Hunting",
			"Biohazard",
			"Demon Slayer",
			"Murder Mystery",
			"Nature Spirit",
			"Witch's House"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			25,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Recipe for Disaster - Evil Dave",
		"relatedQuests": [
			"Recipe for Disaster - Beginning",
			"Gertrude's Cat",
			"Shadow of the Storm"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			41,
			0,
			0,
			0,
			20,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Recipe for Disaster - Skrach",
		"relatedQuests": [
			"Recipe for Disaster - Beginning",
			"Big Chompy Bird Hunting"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Recipe for Disaster - Sir Amik Varze",
		"relatedQuests": [
			"Recipe for Disaster - Beginning",
			"Family Crest",
			"Heroes Quest",
			"Shilo Village",
			"Underground Pass",
			"Waterfall Quest"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			70,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			48,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Recipe for Disaster - Awowogei",
		"relatedQuests": [
			"Recipe for Disaster - Beginning",
			"Monkey Madness"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			70,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			48,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Recipe for Disaster - Final Battle",
		"relatedQuests": [
			"Recipe for Disaster - Beginning",
			"Recipe for Disaster - Dwarf",
			"Recipe for Disaster - Goblins",
			"Recipe for Disaster - Pirate Pete",
			"Recipe for Disaster - Lumbridge Guide",
			"Recipe for Disaster - Evil Dave",
			"Recipe for Disaster - Skrach",
			"Recipe for Disaster - Sir Amik Varze",
			"Recipe for Disaster - Awowogei",
			"Desert Treasure",
			"Horror from the Deep"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			1000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			1000,
			1000,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Recruitment Drive",
		"relatedQuests": [
			"Black Knight's Fortress",
			"Druidic Ritual"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			56,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			13750,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Regicide",
		"relatedQuests": [
			"Underground Pass"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Romeo & Juliet",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			10000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Roving Elves",
		"relatedQuests": [
			"Regicide",
			"Waterfall Quest"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			40,
			0,
			40,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			5000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			5000,
			0,
			5000,
			0,
			0,
			0,
			0
		],
		"name": "Royal Trouble",
		"relatedQuests": [
			"Throne of Miscellania"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			47,
			0,
			0,
			0,
			0,
			50,
			0,
			42,
			0,
			0,
			0,
			0,
			0,
			42,
			40,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			7000,
			0,
			0,
			0,
			0,
			7000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			7000,
			0,
			0,
			0
		],
		"name": "Rum Deal",
		"relatedQuests": [
			"Zogre Flesh Eaters"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Rune Mysteries",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			31,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			6625,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Scorpion Catcher",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			30,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			7125,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			3500,
			0,
			0
		],
		"name": "Sea Slug",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			5,
			20,
			0,
			0,
			5,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			2000,
			0,
			0,
			2000,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Shades of Mort'ton",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			30,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Shadow of the Storm",
		"relatedQuests": [
			"The Golem",
			"Demon Slayer"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Sheep Herder",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			150,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Sheep Shearer",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Shield of Arrav",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			20,
			4,
			0,
			0,
			32,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			3875,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Shilo Village",
		"relatedQuests": [
			"Jungle Potion"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			37,
			0,
			33,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			37,
			0,
			0,
			37,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			8000,
			1000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			1000,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Spirit of the Elid",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			66,
			62,
			0,
			0,
			62,
			42,
			0,
			45,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			10000,
			15000,
			0,
			0,
			0,
			10000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Swan Song",
		"relatedQuests": [
			"One Small Favour",
			"Garden of Tranquility"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			30,
			0,
			0,
			5,
			0,
			0,
			0,
			0,
			0,
			32,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			2500,
			2500,
			0,
			0,
			0,
			0,
			0,
			5000,
			0,
			0,
			5000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Tai Bwo Wannai Trio",
		"relatedQuests": [
			"Jungle Potion"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			49,
			20,
			0,
			20,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			1000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Tears of Guthix",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			40,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			42,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			10500,
			0,
			0,
			0,
			0,
			8000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Temple of Ikov",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			46,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			12000,
			0,
			2500,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			6000,
			0,
			250
		],
		"name": "The Eyes of Glouphrie",
		"relatedQuests": [
			"The Grand Tree"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			30,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			15000,
			0,
			0,
			0,
			0,
			0
		],
		"name": "The Feud",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			56,
			0,
			0,
			0,
			46,
			0,
			0,
			0,
			40,
			0,
			0,
			0,
			0,
			0,
			20
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			10000,
			0,
			0,
			0,
			5000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			5000
		],
		"name": "The Fremennik Isles",
		"relatedQuests": [
			"The Fremennik Trials"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			40,
			25,
			0,
			0,
			40,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			2812,
			2812,
			2812,
			2812,
			0,
			0,
			0,
			0,
			2812,
			2812,
			2812,
			0,
			2812,
			0,
			0,
			0,
			2812,
			2812,
			0,
			0,
			0,
			0,
			0
		],
		"name": "The Fremennik Trials",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			33,
			0,
			0,
			0,
			0,
			0,
			16,
			12,
			0,
			0,
			0,
			0,
			14,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			1500,
			0,
			0,
			0,
			0,
			1500,
			2500,
			2500,
			2500,
			0,
			0,
			1500,
			0,
			0,
			0,
			0,
			0
		],
		"name": "The Giant Dwarf",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			20,
			0,
			0,
			0,
			0,
			25,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			1000,
			0,
			0,
			0,
			0,
			1000,
			0,
			0,
			0,
			0,
			0
		],
		"name": "The Golem",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			25,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			18400,
			0,
			0,
			0,
			0,
			0,
			2150,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			7900,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "The Grand Tree",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			50,
			0,
			0,
			0,
			0,
			0,
			0,
			16,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			30
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			6000,
			0,
			0,
			0,
			0,
			0,
			0,
			3000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			2000
		],
		"name": "The Great Brain Robbery",
		"relatedQuests": [
			"Creature of Fenkenstrain",
			"Recipe for Disaster - Pirate Pete",
			"Run Deal",
			"Cabin Fever"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			49,
			0,
			0,
			0,
			0,
			17,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			9000,
			0,
			0,
			0,
			0,
			1000,
			0,
			0,
			0,
			0,
			0
		],
		"name": "The Hand in the Sand",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			10,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			12725,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "The Knight's Sword",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			17,
			0,
			13,
			13,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "The Lost Tribe",
		"relatedQuests": [
			"Goblin Diplomacy",
			"Rune Mysteries"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			1125,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Restless Ghost",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			3500,
			0,
			0,
			0,
			0,
			3500,
			0,
			0,
			0,
			0,
			0
		],
		"name": "The Slug Menace",
		"relatedQuests": [
			"Sea Slug",
			"Wanted!"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			10,
			0,
			0,
			0,
			20,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "The Tourist Trap",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Throne of Miscellania",
		"relatedQuests": [
			"Heroes Quest",
			"The Fremennik Trials"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			10
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			500,
			0,
			0,
			0,
			0,
			500,
			0,
			0,
			0,
			0,
			1000
		],
		"name": "Tower of Life",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Tree Gnome Village",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			21,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			1775,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Tribal Totem",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			28,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			4000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			8000,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Troll Romance",
		"relatedQuests": [
			"Troll Stronghold",
			"Death Plateau"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			15,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Troll Stronghold",
		"relatedQuests": [
			"Death Plateau"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			25,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			3000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			3000,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Underground Pass",
		"relatedQuests": [
			"Biohazard"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			4825,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Vampire Slayer",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			5000,
			0,
			0,
			0,
			0
		],
		"name": "Wanted!",
		"relatedQuests": [
			"Recruitment Drive",
			"The Lost Tribe",
			"Rune Mysteries",
			"Priest in Peril"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			14,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			40,
			14,
			25,
			15,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			15250,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Watchtower",
		"relatedQuests": [
			"Druidic Ritual"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			13750,
			0,
			13750,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Waterfall Quest",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			42,
			0,
			0,
			0,
			0,
			0,
			35,
			0,
			0
		],
		"reward": [
			0,
			0,
			2000,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			8000,
			0,
			0
		],
		"name": "What Lies Below",
		"relatedQuests": [
			"Rune Mysteries"
		]
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			6325,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Witch's House",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			325,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Witch's Potion",
		"relatedQuests": []
	},
	{
		"requirement": [
			0,
			0,
			0,
			20,
			0,
			30,
			0,
			0,
			0,
			0,
			30,
			0,
			0,
			0,
			4,
			0,
			8,
			0,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"reward": [
			0,
			0,
			0,
			0,
			0,
			2000,
			0,
			0,
			0,
			0,
			2000,
			0,
			0,
			0,
			0,
			0,
			0,
			2000,
			0,
			0,
			0,
			0,
			0,
			0
		],
		"name": "Zogre Flesh Eaters",
		"relatedQuests": [
			"Jungle Potion",
			"Big Chompy Bird Hunting"
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/quests.json
// module id = 143
// module chunks = 1